if (!customElements.get('free-shipping-bar')) {
  customElements.define(
    'free-shipping-bar',
    class FreeShippingBar extends HTMLElement {
      constructor() {
        super();
        this.thresholdCents = parseInt(this.dataset.thresholdCents, 10) || 0;
        this.moneyFormat = '${{amount}}';
        try {
          this.moneyFormat = JSON.parse(this.dataset.moneyFormat) || this.moneyFormat;
        } catch (e) {
          // keep default format
        }
        this.textBelow = this.dataset.textBelow || "You're [amount] away from FREE shipping!";
        this.textQualified = this.dataset.textQualified || "You've unlocked FREE shipping!";

        this.track = this.querySelector('[data-free-shipping-track]');
        this.fill = this.querySelector('[data-free-shipping-fill]');
        this.message = this.querySelector('[data-free-shipping-message]');
        this.icon = this.querySelector('[data-free-shipping-icon]');
      }

      connectedCallback() {
        this.refresh();
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      refresh() {
        fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' })
          .then((response) => response.json())
          .then((cart) => this.render(cart.total_price))
          .catch(() => {});
      }

      render(cartTotalCents) {
        if (this.thresholdCents <= 0) return;

        const remainingCents = this.thresholdCents - cartTotalCents;
        const qualified = remainingCents <= 0;
        const percent = Math.min(100, Math.max(0, (cartTotalCents / this.thresholdCents) * 100));

        if (this.fill) this.fill.style.width = `${percent}%`;
        if (this.track) this.track.setAttribute('aria-valuenow', Math.round(percent));
        this.classList.toggle('free-shipping-bar--qualified', qualified);

        if (this.message) {
          if (qualified) {
            this.message.textContent = this.textQualified;
          } else {
            const amount = this.formatMoney(remainingCents, this.moneyFormat);
            this.message.textContent = this.textBelow.replace('[amount]', amount);
          }
        }
      }

      formatMoney(cents, format) {
        const placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const key = placeholderMatch ? placeholderMatch[1] : 'amount';

        let precision = 2;
        let thousands = ',';
        let decimal = '.';

        if (key === 'amount_no_decimals') {
          precision = 0;
        } else if (key === 'amount_with_comma_separator') {
          thousands = '.';
          decimal = ',';
        } else if (key === 'amount_no_decimals_with_comma_separator') {
          precision = 0;
          thousands = '.';
          decimal = ',';
        } else if (key === 'amount_with_apostrophe_separator') {
          thousands = "'";
        }

        const amount = Math.max(0, cents) / 100;
        const parts = amount.toFixed(precision).split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
        const value = parts[1] ? dollars + decimal + parts[1] : dollars;

        return placeholderMatch ? format.replace(placeholderMatch[0], value) : `${format}${value}`;
      }
    }
  );
}
